import addGoogleSheetRow from './add-google-sheet-row';
import askQuestion from './ask-question';
import assign from './assign';
import automationConnector from './automation-connector';
import branch from './branch';
import closeConversation from './close-conversation';
import dateTime from './date-time';
import httpRequest from './http-request';
import jump from './jump';
import openConversation from './open-conversation';
import pasteStep from './paste-step';
import pasteStepWithSubsteps from './paste-step-with-substeps';
import AddPrivateNote from './private-note';
import sendCsat from './send-csat';
import sendMessage from './send-message';
import StartAnotherWorkflow from './start-another-workflow';
import trigger from './trigger';
import updateContactField from './update-contact-field';
import updateContactTag from './update-contact-tag';
import wait from './wait';

import type { StepConfig } from '../../types/workflow';

// Combined step configurations
// Note: Steps with category 'Trigger' or 'Connector' are system-generated
// and automatically excluded from the dropdown
export const stepConfigs: Record<string, StepConfig> = {
  Trigger: trigger,
  SendMessage: sendMessage,
  AskQuestion: askQuestion,
  Branch: branch,
  DateTime: dateTime,
  Jump: jump,
  OpenConversation: openConversation,
  CloseConversation: closeConversation,
  AddPrivateNote: AddPrivateNote,
  UpdateContactTag: updateContactTag,
  Wait: wait,
  Assign: assign,
  HttpRequest: httpRequest,
  UpdateContactField: updateContactField,
  StartAnotherWorkflow: StartAnotherWorkflow,
  PasteStep: pasteStep,
  PasteStepWithSubsteps: pasteStepWithSubsteps,
  SendCsat: sendCsat,
  AddGoogleSheetRow: addGoogleSheetRow,
  Automation: automationConnector,
};
